<div class="TotemWidget TotemWidgetButtons" role="navigation" [attr.aria-label]="'totem-a11y.quick-links' | locTranslate">
    <div class="row">
        @for (button of buttonList; track button; let i = $index) {
            <div class="col-3">
                <button type="button" class="btn bg-white btn-block shadow-sm" (click)="onButtonClick(i)" [attr.aria-label]="button.text + ' ' + ('totem-a11y.opens-new-window' | locTranslate)">
                    <i class="fa-solid {{button.icon}} text-secondary m-0" aria-hidden="true"></i>
                    <div class="small" aria-hidden="true">{{button.text}}</div>
                </button>
            </div>
        }
    </div>
</div>
